import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, Sparkles, Zap } from 'lucide-react';

const SeriesCTA = ({ series }) => {
  return (
    <section className="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0">
        <div 
          className="absolute top-0 left-1/4 w-96 h-96 rounded-full blur-3xl opacity-10" 
          style={{ backgroundColor: series.accentColor }}
        />
        <div 
          className="absolute bottom-0 right-1/4 w-80 h-80 rounded-full blur-3xl opacity-10"
          style={{ backgroundColor: series.accentColor }}
        />
      </div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <div 
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium mb-6"
            style={{ 
              backgroundColor: `${series.accentColor}30`,
              color: series.accentColor 
            }}
          >
            <Sparkles className="w-4 h-4" />
            Start Your Leadership Journey
          </div>

          <h2 className="text-3xl lg:text-5xl font-bold text-white mb-5 leading-tight">
            Ready to Lead with
            <span style={{ color: series.accentColor }}> Clarity?</span>
          </h2>

          <p className="text-lg text-slate-400 mb-8 max-w-xl mx-auto">
            Begin with the free tier. Upgrade when you need deeper memory, pattern analysis, and career-grade exports.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-10">
            <Button 
              size="lg" 
              className="text-white px-8 py-6 text-lg group transition-all duration-300 shadow-lg"
              style={{ 
                backgroundColor: series.accentColor,
                boxShadow: `0 10px 40px ${series.accentColor}40`
              }}
              onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
              data-testid="cta-start-free-btn"
            >
              <Zap className="w-5 h-5 mr-2" />
              Start Free
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-slate-600 text-slate-300 hover:bg-slate-800 px-8 py-6 text-lg"
              onClick={() => document.getElementById('try-companion')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Try Demo First
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-500">
            <div className="flex items-center gap-2">
              <svg className="w-4 h-4 text-emerald-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span>No card required</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="w-4 h-4 text-emerald-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span>Cancel anytime</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="w-4 h-4 text-emerald-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span>Upgrade when ready</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SeriesCTA;
